import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';

const Navbar = ({ setCartOpen }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const refreshUserData = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      const response = await api.get('auth/me', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser(response.data);
      localStorage.setItem('user', JSON.stringify(response.data));
    } catch (error) {
      console.error('Error refreshing user data:', error);
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    refreshUserData();
    // eslint-disable-next-line
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    setUser(null);
    setCartOpen(false);
    navigate('/');
  };

  const toggleCart = () => {
    setCartOpen((prev) => !prev);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-success shadow-sm sticky-top">
      <div className="container">
        <Link className="navbar-brand fw-bold d-flex align-items-center" to="/">
          <img
            src="/logo.png"
            alt="Logo"
            style={{ width: '40px', height: 'auto', marginRight: '8px' }}
          />
          Iovendosiciliano
        </Link>

        <button
          className="navbar-toggler border-white"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link text-white text-uppercase" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-white text-uppercase" to="/products">Products</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-white text-uppercase" to="/about">About Us</Link>
            </li>

            {user?.role === 'seller' && (
              <>
                <li className="nav-item">
                  {user.approved ? (
                    <Link className="nav-link text-white text-uppercase" to="/add-product">
                      Add Product
                    </Link>
                  ) : (
                    <span className="nav-link text-white-50 text-uppercase" title="Not approved">
                      Add Product
                    </span>
                  )}
                </li>

                {user.approved && (
                  <>
                    <li className="nav-item">
                      <Link className="nav-link text-white text-uppercase" to="/seller/orders">
                        Seller Orders
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link text-white text-uppercase" to="/seller/edit-products">
                        Edit Products
                      </Link>
                    </li>
                  </>
                )}
              </>
            )}

            {user?.role === 'admin' && (
              <>
                <li className="nav-item">
                  <Link className="nav-link text-white text-uppercase" to="/pending-sellers">
                    Pending Seller
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link text-white text-uppercase" to="/admin/users">
                    Manage Users
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link text-white text-uppercase" to="/admin/products">
                    Manage Products
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link text-white text-uppercase" to="/admin/orders">
                    Manage Orders
                  </Link>
                </li>
              </>
            )}
          </ul>

          <ul className="navbar-nav ms-auto align-items-center gap-2">
            {user ? (
              <>
              <li className="nav-item dropdown">
              <button
                className="nav-link dropdown-toggle text-white bg-transparent border-0 fw-semibold"
                id="userDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ cursor: 'pointer' }}
              >
                <i className="bi bi-person-circle me-1"></i> {user.name}
              </button>
              <ul className="dropdown-menu dropdown-menu-end shadow-sm border-0">
                <li>
                  <button className="dropdown-item" onClick={() => navigate('/profile')}>
                    Profile
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={() => navigate('/my-orders')}>
                    My Orders
                  </button>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <button className="dropdown-item text-danger" onClick={handleLogout}>
                    Logout
                  </button>
                </li>
              </ul>
            </li>
                <li>
                  <button className="btn btn-outline-light" onClick={toggleCart}>
                    <i className="bi bi-cart"></i>
                  </button>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link className="btn btn-outline-light fw-bold" to="/login">
                    Login
                  </Link>
                </li>
                <li>
                  <Link className="btn btn-light text-success fw-bold" to="/register">
                    Register
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
